export type HttpErrorKind = 'network' | 'timeout' | 'client' | 'server' | 'parse';

export class HttpError extends Error {
  constructor(
    readonly kind: HttpErrorKind,
    readonly url: string,
    readonly status: number | null,
    message: string,
  ) {
    super(message);
    this.name = 'HttpError';
  }

  static fromStatus(url: string, status: number, message: string): HttpError {
    if (status === 0) {
      return new HttpError('network', url, status, message);
    }
    return new HttpError(status >= 500 ? 'server' : 'client', url, status, message);
  }

  get isRetryable(): boolean {
    return this.kind === 'network' || this.kind === 'timeout' || this.kind === 'server';
  }
}
